import { createSelector } from 'reselect';

export const getBookingTimeSlotLoadingStatus = state =>
  state.booking.loadingStatus;

export const getPractitionersData = createSelector(
  state => state.booking.practitioners,
  practitioners => practitioners || [],
);

export const getCurrentStep = state => state.booking.currentStep;
export const getPreviousStep = state => state.booking.previousStep;

export const getInitialStep = state => state.booking.previousStep[0];

export const checkIsFromExternalSource = state =>
  state.booking.isFromExternalSource;

export const getBookingTimeSlotData = createSelector(
  state => state.booking.bookingSlots,
  bookingSlots => bookingSlots || {},
);

export const getNextAvailableBookingTimeSlotData = createSelector(
  state => state.booking.nextAvailableBookingSlots,
  nextAvailableBookingSlots => nextAvailableBookingSlots || {},
);

export const getBookingTimeSlotHolding = createSelector(
  state => state.booking.bookingSlotHolding,
  bookingSlotHolding => bookingSlotHolding || {},
);

export const getIsHoldingCreateBooking = createSelector(
  state => state.booking.isHoldingCreateBooking,
  isHoldingCreateBooking => isHoldingCreateBooking || false,
);

export const getAppointmentCreated = createSelector(
  state => state.booking.appointmentCreated,
  appointmentCreated => appointmentCreated || {},
);
